const initialState = {
    code: '',
    timerTime: 0,
};
const verification = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_VERIFICATION':
           return {...state, [action.name]: action.value};
        case 'CHANGE_TIMER_TIME_PAGE_VERIFICATION':
            return {...state, timerTime: action.timer_time};
        default:
            return state;
    }
};

export default verification;
